import {FlowBlock} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {FocusUtil} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/FocusActivator';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Scrollable, ScrollAppearance, ScrollBehavior} from '@mintdata-wsp/wsp/ui/components/scrollable/Scrollable';
import {FlowBlockView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/canvas/FlowBlockView';
import {FlowWiresView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/canvas/FlowWiresView';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {HotKeys} from 'react-hotkeys';

const styles = require('./FlowCanvas.less');
const cx = classnames.bind(styles);

@observer
export class FlowCanvas extends React.Component<any, any>
{
    public componentDidMount()
    {
        controllers.ui.flowCanvas.applyCanvasExtent();
    }

    public componentDidUpdate()
    {
        this.componentDidMount();
    }

    @bind
    private _onFlowCanvasRef(ref:HTMLElement|null)
    {
        controllers.ui.flowCanvas.setCanvasDomElement(ref);
        this._setViewFocusActivator();
    }

    @bind
    private _setViewFocusActivator():void
    {
        const canvasDomElement:HTMLElement|null = controllers.ui.flowCanvas.getCanvasDomElement();
        const canvasFocusActivator = canvasDomElement
            ? FocusUtil.focusActivator(this._onCanvasFocus)
            : null;

        controllers.ui.flowCanvas.setCanvasFocusActivator(canvasFocusActivator);
    }

    @bind
    private _onCanvasFocus():void
    {
        const canvasDomElement:HTMLElement|null = controllers.ui.flowCanvas.getCanvasDomElement();

        canvasDomElement && canvasDomElement.focus();
    }

    public render()
    {
        const {flowCanvas, flow, flowCanvasKeyboard} = controllers.ui;

        const openFlow = flow.getOpenFlow();
        const flowBlocks:FlowBlock[] = flowCanvas.getCurrentFlowBlocks();

        return (
            <Scrollable
                className={cx('flowCanvasBg')}
                isScrollX={true}
                isScrollY={true}
                behavior={ScrollBehavior.OnHover}
                appearance={ScrollAppearance.ForLightBlueContent}
            >
                <HotKeys keyMap={flowCanvasKeyboard.getKeyMap()} handlers={flowCanvasKeyboard.getKeyHandlers()}>
                    <div className={cx('flowCanvas')} ref={this._onFlowCanvasRef} tabIndex={-1}>
                        <FlowWiresView />
                        {
                            flowBlocks &&
                            flowBlocks
                                .filter(({isEntryBlock}) => !isEntryBlock)
                                .map((flowBlock:FlowBlock) =>
                                {
                                    const isSelected = controllers.ui.flowSelection.isBlockSelected(flowBlock);

                                    return (
                                        <FlowBlockView
                                            key={flowBlock.id}
                                            flowId={openFlow.id}
                                            block={flowBlock}
                                            isSelected={isSelected}
                                        />
                                    );
                                })
                        }
                    </div>
                </HotKeys>
            </Scrollable>
        );
    }
}
